import React from 'react';
import { Card, Grid } from '@mui/material';
import ModernButton from './ModernButton';

/**
 * FilterCard - A card containing filter controls with an apply button
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Filter input elements
 * @param {Function} props.onApply - Callback when apply button is clicked
 * @param {Function} props.onReset - Callback when reset button is clicked (optional)
 * @param {string} props.applyLabel - Label for apply button (default: 'Apply Filters')
 * @param {boolean} props.showReset - Whether to show reset button (default: false)
 * @param {number} props.filterColumns - Number of columns for filters (default: 3)
 */
const FilterCard = ({
  children,
  onApply,
  onReset,
  applyLabel = 'Apply Filters',
  showReset = false,
  filterColumns = 3,
}) => {
  // Convert children to array for grid layout
  const childArray = React.Children.toArray(children);
  const mdSize = 12 / (filterColumns + 1); // +1 for the button column

  return (
    <Card sx={{ mb: 3, p: 3, borderRadius: 3 }}>
      <Grid container spacing={2} alignItems="flex-end">
        {childArray.map((child, index) => (
          <Grid item xs={12} md={mdSize} key={index}>
            {child}
          </Grid>
        ))}
        <Grid item xs={12} md={mdSize}>
          <Grid container spacing={1}>
            <Grid item xs={showReset ? 6 : 12}>
              <ModernButton
                fullWidth
                variant="contained"
                onClick={onApply}
              >
                {applyLabel}
              </ModernButton>
            </Grid>
            {showReset && onReset && (
              <Grid item xs={6}>
                <ModernButton
                  fullWidth
                  variant="outlined"
                  onClick={onReset}
                >
                  Reset
                </ModernButton>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default FilterCard;
